exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__files___1eACP{margin-bottom:1em}.index-module__files___1eACP .index-module__file___18H0i{margin-bottom:.25em;color:#707070;font-weight:500}.index-module__files___1eACP .index-module__file___18H0i svg{margin-left:.5em;transform:translateY(1px)}.index-module__uploadButton___3v81o input{display:none}.index-module__uploadButton___3v81o label{width:50px;height:50px;background-color:#f1f0ea;border-radius:5px;cursor:pointer;display:flex;justify-content:center;align-items:center;margin:0}.index-module__uploadButton___3v81o label svg{color:#1e265c;font-size:1.5em}.index-module__uploadButton___3v81o .index-module__grid___dAjDd{display:grid;grid-template-columns:auto auto;gap:1em;justify-content:left;align-items:center}", ""]);

// exports
exports.locals = {
	"files": "index-module__files___1eACP",
	"file": "index-module__file___18H0i",
	"uploadButton": "index-module__uploadButton___3v81o",
	"grid": "index-module__grid___dAjDd"
};